import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider as MUIThemeProvider, } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { deepmerge } from '@mui/utils';
import { useMemo } from 'react';
import { getColorPalette } from './theme/colors';
import { typography } from './theme/typography';
import { utils } from './theme/utils';
import './index.css';
export const ThemeProvider = ({ children, theme, forcedMode, }) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const systemMode = prefersDarkMode ? 'dark' : 'light';
    const mode = forcedMode || systemMode;
    const mergedTheme = useMemo(() => createTheme(deepmerge({
        palette: getColorPalette(mode),
        typography,
        shape: {
            borderRadius: 8,
        },
        utils,
    }, theme || {})), [mode, theme]);
    return (_jsxs(MUIThemeProvider, { theme: mergedTheme, children: [_jsx(CssBaseline, { enableColorScheme: true }), children] }));
};
